export const STATUS_MESSAGE = {
	// ID status zprav
	ADVERT_HAS_VIDEO: 'advert-has-video',
	CREATE_ADVERT_OK: 'status-message-create-advert-ok',
	EDIT_ADVERT_OK: 'status-message-edit-advert-ok',
	EDIT_ADVERT_ERROR: 'status-message-edit-advert-error',
	EDIT_ADVERT_FATAL_ERROR: 'status-message-edit-advert-fatal-error',
	EDIT_ADVERT_NOT_CHANGED_ERROR: 'status-message-edit-advert-not-changed-error',
	CHANGE_FILE_ORDER_ERROR: 'status-message-change-image-order-error',
	UPLOADED_IMAGE_TOO_SMALL_ERROR: 'uploaded-image-too-small-error',
	UPLOADED_IMAGE_TOO_BIG_ERROR: 'uploaded-image-too-big-error',
	UPLOADED_IMAGE_BAD_TYPE_ERROR: 'uploaded-image-bad-type-error',
	UPLOADED_IMAGE_ERROR: 'uploaded-image-error',
	UPLOADED_IMAGE_UNKNOWN_ERROR: 'uploaded-image-unknown-error',
	UPLOADED_IMAGE_DUPLICITY_ERROR: 'uploaded-image-duplicity-error',
	DELETE_IMAGE_ERROR: 'delete-image-error',
	UPLOADED_VIDEO_TOO_SMALL_ERROR: 'uploaded-video-too-small-error',
	UPLOADED_VIDEO_TOO_BIG_ERROR: 'uploaded-video-too-big-error',
	UPLOADED_VIDEO_BAD_TYPE_ERROR: 'uploaded-video-bad-type-error',
	UPLOADED_VIDEO_ERROR: 'uploaded-video-error',
	UPLOADED_VIDEO_UNKNOWN_ERROR: 'uploaded-video-unknown-error',
	DELETE_VIDEO_ERROR: 'delete-video-error',
	REVIVING_ADVERT_DONE: 'reviving_advert_done',
	REVIVING_ADVERT_WRONG_HASH: 'reviving_advert_wrong_hash',
	REVIVING_ADVERT_DELETED: 'reviving-advert-deleted',
	ADVERT_NOT_FOUND: 'advert-not-found',
	CONTACT_FORM_MSG_SENT: 'contact-form-msg-sent',
	CONTACT_FORM_SEND_FAILED: 'contact-form-send-failed',
	CONTACT_FORM_MSG_ERROR: 'contact-form-msg-error',
	FEEDBACK_SENT: 'feedback-sent',
	PROFILE_SAVED: 'profile-saved',
	ADVERT_REPORT_SENT: 'advert-report-sent',
	PIN_MESSAGE_COUNT: 'pin-message-count',
	PIN_MESSAGE: 'pin-message',
	PIN_VERIFICATION_ERROR: 'pin-verification-error',
	WALLET_TOP_UP_OK: 'wallet-top-up-ok',
	WALLET_TOP_UP_ERROR: 'wallet-top-up-error',
	URL_COPIED: 'status-message-url-copied',

	LOCATING_DISABLED: 'locating-disabled',
	LOCATING_ABROAD: 'locating-abroad',
	LOCATING_NOT_FOUND: 'locating-not-found',
	LOCATING_TIMEOUT: 'locating-timeout',

	// konstanty jsou sestavene z predpony payment-wallet- a error_code co chodi z API
	PAYMENT_WALLET_ADVERT_NOT_ACTIVE: 'payment-wallet-advert_not_active',
	PAYMENT_WALLET_NOT_OWNER: 'payment-wallet-not_owner',
	PAYMENT_WALLET_USER_WITHOUT_WALLET: 'payment-wallet-user_without_wallet',
	PAYMENT_WALLET_USER_BLOCKED: 'payment-wallet-user_blocked',
	PAYMENT_WALLET_LOW_CREDIT: 'payment-wallet-low_credit',
	PAYMENT_WALLET_FAILED: 'payment-wallet-payment_failed',

	// konstanty jsou sestavene z predpony payment-voucher- a error_code co chodi z API
	PAYMENT_VOUCHER_LACK_OF_VOUCHERS: 'payment-voucher-lack_of_vouchers',
	PAYMENT_VOUCHER_FAILED: 'payment-voucher-payment_failed',

	// konstanty jsou sestavene z predpony payment-credit_card- a error_code co chodi z API
	PAYMENT_CREDIT_CARD_FAILED: 'payment-credit_card-payment_failed',
	PAYMENT_CREDIT_CARD_UNAVAILABLE: 'payment-credit_card-payment_unavailable',
	PAYMENT_CREDIT_CARD_INVALID: 'payment-credit_card-payment_invalid_payment_type',
	PAYMENT_CREDIT_CARD_ADVERT_NOT_ACTIVE: 'payment-credit_card-advert_not_active',
	PAYMENT_CREDIT_CARD_NOT_OWNER: 'payment-credit_card-not_owner',
	PAYMENT_CREDIT_CARD_ERROR: 'payment-credit_card-error',

	ADVERT_ACTION_ERROR: 'advert-action-error',
	ADVERT_RESERVED_ERROR: 'advert-reserved-error',

	ADVERT_NOT_ACTIVE: 'advert-not-active',
	FAVORITE_GENERIC_ADD_ERROR: 'favorite-generic-add-error',
	FAVORITE_GENERIC_REMOVE_ERROR: 'favorite-generic-remove-error',

	WATCH_DOG_DOESNT_EXIST_ERROR: 'watch-dog-doesnt-exist-error',
	WATCH_DOG_CREATED_SUCCESS: 'watch-dog-created-success',
	WATCH_DOG_CREATED_ERROR: 'watch-dog-created-error',
	WATCH_DOG_UPDATED_SUCCESS: 'watch-dog-updated-success',
	WATCH_DOG_UPDATED_ERROR: 'watch-dog-updated-error',
	WATCH_DOG_DELETED_SUCCESS: 'watch-dog-deleted-success',
	WATCH_DOG_DELETED_ERROR: 'watch-dog-deleted-error',

	BANKID_STATUS_SUCCESS: 'bankid-status-success',
	BANKID_STATUS_ERROR: 'bankid-status-error',
	BANKID_STATUS_MISMATCH: 'bankid-status-mismatch',
	BANKID_STATUS_ACCESS_DENIED: 'bankid-status-access-denied',
	BANKID_STATUS_EID_DOESNT_EXIST: 'bankid-status-eid-doesnt-exist',

	MOJEID_STATUS_SUCCESS: 'mojeid-status-success',
	MOJEID_STATUS_ERROR: 'mojeid-status-error',
	MOJEID_STATUS_INCOMPLETE: 'mojeid-status-incomplete',
	MOJEID_STATUS_MISMATCH: 'mojeid-status-mismatch',
} as const;

export type StatusMessage = (typeof STATUS_MESSAGE)[keyof typeof STATUS_MESSAGE];

export const STATUS_MESSAGE_TYPE = {
	INFO: 'info',
	SUCCESS: 'success',
	ERROR: 'error',
} as const;

export type StatusMessageType = (typeof STATUS_MESSAGE_TYPE)[keyof typeof STATUS_MESSAGE_TYPE];

export const TYPE_BY_STATUS_MESSAGE = {
	[STATUS_MESSAGE.ADVERT_HAS_VIDEO]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.CREATE_ADVERT_OK]: STATUS_MESSAGE_TYPE.SUCCESS,
	[STATUS_MESSAGE.EDIT_ADVERT_OK]: STATUS_MESSAGE_TYPE.SUCCESS,
	[STATUS_MESSAGE.EDIT_ADVERT_ERROR]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.EDIT_ADVERT_FATAL_ERROR]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.EDIT_ADVERT_NOT_CHANGED_ERROR]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.CHANGE_FILE_ORDER_ERROR]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.UPLOADED_IMAGE_TOO_SMALL_ERROR]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.UPLOADED_IMAGE_TOO_BIG_ERROR]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.UPLOADED_IMAGE_BAD_TYPE_ERROR]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.UPLOADED_IMAGE_ERROR]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.UPLOADED_IMAGE_UNKNOWN_ERROR]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.UPLOADED_IMAGE_DUPLICITY_ERROR]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.DELETE_IMAGE_ERROR]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.UPLOADED_VIDEO_TOO_SMALL_ERROR]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.UPLOADED_VIDEO_TOO_BIG_ERROR]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.UPLOADED_VIDEO_BAD_TYPE_ERROR]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.UPLOADED_VIDEO_ERROR]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.UPLOADED_VIDEO_UNKNOWN_ERROR]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.DELETE_VIDEO_ERROR]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.REVIVING_ADVERT_DONE]: STATUS_MESSAGE_TYPE.SUCCESS,
	[STATUS_MESSAGE.REVIVING_ADVERT_WRONG_HASH]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.REVIVING_ADVERT_DELETED]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.ADVERT_NOT_FOUND]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.CONTACT_FORM_MSG_SENT]: STATUS_MESSAGE_TYPE.SUCCESS,
	[STATUS_MESSAGE.CONTACT_FORM_SEND_FAILED]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.CONTACT_FORM_MSG_ERROR]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.FEEDBACK_SENT]: STATUS_MESSAGE_TYPE.SUCCESS,
	[STATUS_MESSAGE.PROFILE_SAVED]: STATUS_MESSAGE_TYPE.SUCCESS,
	[STATUS_MESSAGE.ADVERT_REPORT_SENT]: STATUS_MESSAGE_TYPE.SUCCESS,
	[STATUS_MESSAGE.PIN_MESSAGE_COUNT]: STATUS_MESSAGE_TYPE.INFO,
	[STATUS_MESSAGE.PIN_MESSAGE]: STATUS_MESSAGE_TYPE.INFO,
	[STATUS_MESSAGE.PIN_VERIFICATION_ERROR]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.WALLET_TOP_UP_OK]: STATUS_MESSAGE_TYPE.SUCCESS,
	[STATUS_MESSAGE.WALLET_TOP_UP_ERROR]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.URL_COPIED]: STATUS_MESSAGE_TYPE.INFO,
	[STATUS_MESSAGE.LOCATING_DISABLED]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.LOCATING_ABROAD]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.LOCATING_NOT_FOUND]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.LOCATING_TIMEOUT]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.PAYMENT_WALLET_ADVERT_NOT_ACTIVE]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.PAYMENT_WALLET_NOT_OWNER]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.PAYMENT_WALLET_USER_WITHOUT_WALLET]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.PAYMENT_WALLET_USER_BLOCKED]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.PAYMENT_WALLET_LOW_CREDIT]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.PAYMENT_WALLET_FAILED]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.PAYMENT_VOUCHER_LACK_OF_VOUCHERS]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.PAYMENT_VOUCHER_FAILED]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.PAYMENT_CREDIT_CARD_FAILED]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.PAYMENT_CREDIT_CARD_UNAVAILABLE]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.PAYMENT_CREDIT_CARD_INVALID]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.PAYMENT_CREDIT_CARD_ADVERT_NOT_ACTIVE]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.PAYMENT_CREDIT_CARD_NOT_OWNER]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.PAYMENT_CREDIT_CARD_ERROR]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.ADVERT_ACTION_ERROR]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.ADVERT_RESERVED_ERROR]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.ADVERT_NOT_ACTIVE]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.FAVORITE_GENERIC_ADD_ERROR]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.FAVORITE_GENERIC_REMOVE_ERROR]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.WATCH_DOG_DOESNT_EXIST_ERROR]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.WATCH_DOG_CREATED_SUCCESS]: STATUS_MESSAGE_TYPE.SUCCESS,
	[STATUS_MESSAGE.WATCH_DOG_CREATED_ERROR]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.WATCH_DOG_UPDATED_SUCCESS]: STATUS_MESSAGE_TYPE.SUCCESS,
	[STATUS_MESSAGE.WATCH_DOG_UPDATED_ERROR]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.WATCH_DOG_DELETED_SUCCESS]: STATUS_MESSAGE_TYPE.SUCCESS,
	[STATUS_MESSAGE.WATCH_DOG_DELETED_ERROR]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.BANKID_STATUS_SUCCESS]: STATUS_MESSAGE_TYPE.SUCCESS,
	[STATUS_MESSAGE.BANKID_STATUS_ERROR]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.BANKID_STATUS_MISMATCH]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.BANKID_STATUS_ACCESS_DENIED]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.BANKID_STATUS_EID_DOESNT_EXIST]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.MOJEID_STATUS_SUCCESS]: STATUS_MESSAGE_TYPE.SUCCESS,
	[STATUS_MESSAGE.MOJEID_STATUS_ERROR]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.MOJEID_STATUS_INCOMPLETE]: STATUS_MESSAGE_TYPE.ERROR,
	[STATUS_MESSAGE.MOJEID_STATUS_MISMATCH]: STATUS_MESSAGE_TYPE.ERROR,
} as const;

export const STATUS_MESSAGE_TO_TRANSLATE_KEY = {
	[STATUS_MESSAGE.ADVERT_HAS_VIDEO]: 'advertHasVideo',
	[STATUS_MESSAGE.EDIT_ADVERT_OK]: 'editAdvertStatusOk',
	[STATUS_MESSAGE.EDIT_ADVERT_ERROR]: 'editAdvertStatusError',
	[STATUS_MESSAGE.EDIT_ADVERT_FATAL_ERROR]: 'editAdvertFatalError',
	[STATUS_MESSAGE.EDIT_ADVERT_NOT_CHANGED_ERROR]: 'editAdvertNotChangedStatusError',
	[STATUS_MESSAGE.CHANGE_FILE_ORDER_ERROR]: 'changeOrderFileErrorMsg',
	[STATUS_MESSAGE.UPLOADED_IMAGE_TOO_SMALL_ERROR]: 'uploadedImageTooSmallErrorMsg',
	[STATUS_MESSAGE.UPLOADED_IMAGE_TOO_BIG_ERROR]: 'uploadedImageTooBigErrorMsg',
	[STATUS_MESSAGE.UPLOADED_IMAGE_BAD_TYPE_ERROR]: 'uploadedImageBadTypeErrorMsg',
	[STATUS_MESSAGE.UPLOADED_IMAGE_ERROR]: 'uploadedImageErrorMsg',
	[STATUS_MESSAGE.UPLOADED_IMAGE_UNKNOWN_ERROR]: 'uploadedImageUnknownErrorMsg',
	[STATUS_MESSAGE.UPLOADED_IMAGE_DUPLICITY_ERROR]: 'uploadedImageDuplicityErrorMsg',
	[STATUS_MESSAGE.DELETE_VIDEO_ERROR]: 'deleteVideoErrorMsg',
	[STATUS_MESSAGE.UPLOADED_VIDEO_TOO_SMALL_ERROR]: 'uploadedVideoTooSmallErrorMsg',
	[STATUS_MESSAGE.UPLOADED_VIDEO_TOO_BIG_ERROR]: 'uploadedVideoTooBigErrorMsg',
	[STATUS_MESSAGE.UPLOADED_VIDEO_BAD_TYPE_ERROR]: 'uploadedVideoBadTypeErrorMsg',
	[STATUS_MESSAGE.UPLOADED_VIDEO_ERROR]: 'uploadedVideoErrorMsg',
	[STATUS_MESSAGE.DELETE_IMAGE_ERROR]: 'deleteImageErrorMsg',
	[STATUS_MESSAGE.REVIVING_ADVERT_DONE]: 'revivingAdvertDone',
	[STATUS_MESSAGE.REVIVING_ADVERT_WRONG_HASH]: 'revivingAdvertWrongHash',
	[STATUS_MESSAGE.REVIVING_ADVERT_DELETED]: 'revivingAdvertDeleted',
	[STATUS_MESSAGE.ADVERT_NOT_FOUND]: 'advertNotFound',
	[STATUS_MESSAGE.CONTACT_FORM_MSG_SENT]: 'contactFormMessageSent',
	[STATUS_MESSAGE.CONTACT_FORM_SEND_FAILED]: 'contactFormMessageSendFailed',
	[STATUS_MESSAGE.CONTACT_FORM_MSG_ERROR]: 'contactFormMessageError',
	[STATUS_MESSAGE.FEEDBACK_SENT]: 'feedbackSent',
	[STATUS_MESSAGE.PROFILE_SAVED]: 'profileSaved',
	[STATUS_MESSAGE.ADVERT_REPORT_SENT]: 'feedbackSent',
	[STATUS_MESSAGE.PIN_MESSAGE_COUNT]: 'pinMessageCount',
	[STATUS_MESSAGE.PIN_MESSAGE]: 'pinMessage',
	[STATUS_MESSAGE.PIN_VERIFICATION_ERROR]: 'pinVerificationError',
	[STATUS_MESSAGE.WALLET_TOP_UP_OK]: 'walletTopUpOk',
	[STATUS_MESSAGE.WALLET_TOP_UP_ERROR]: 'walletTopUpError',
	[STATUS_MESSAGE.URL_COPIED]: 'urlCopied',
	[STATUS_MESSAGE.LOCATING_DISABLED]: 'locatingDisabled',
	[STATUS_MESSAGE.LOCATING_ABROAD]: 'locatingAbroad',
	[STATUS_MESSAGE.LOCATING_NOT_FOUND]: 'locatingNotFound',
	[STATUS_MESSAGE.PAYMENT_WALLET_ADVERT_NOT_ACTIVE]: 'toppingAdvertNotActive',
	[STATUS_MESSAGE.PAYMENT_WALLET_NOT_OWNER]: 'toppingNotOwner',
	[STATUS_MESSAGE.PAYMENT_WALLET_USER_WITHOUT_WALLET]: 'paymentWalletUserWithoutWallet',
	[STATUS_MESSAGE.PAYMENT_WALLET_USER_BLOCKED]: 'paymentWalletUserBlocked',
	[STATUS_MESSAGE.PAYMENT_WALLET_LOW_CREDIT]: 'paymentWalletLowCredit',
	[STATUS_MESSAGE.PAYMENT_WALLET_FAILED]: 'toppingFailed',
	[STATUS_MESSAGE.PAYMENT_VOUCHER_LACK_OF_VOUCHERS]: 'paymentVoucherLackOfVouchers',
	[STATUS_MESSAGE.PAYMENT_VOUCHER_FAILED]: 'toppingFailed',
	[STATUS_MESSAGE.PAYMENT_CREDIT_CARD_FAILED]: 'toppingFailed',
	[STATUS_MESSAGE.PAYMENT_CREDIT_CARD_UNAVAILABLE]: 'paymentCardUnavailable',
	[STATUS_MESSAGE.PAYMENT_CREDIT_CARD_INVALID]: 'paymentCardInvalidType',
	[STATUS_MESSAGE.PAYMENT_CREDIT_CARD_ADVERT_NOT_ACTIVE]: 'toppingAdvertNotActive',
	[STATUS_MESSAGE.PAYMENT_CREDIT_CARD_NOT_OWNER]: 'toppingNotOwner',
	[STATUS_MESSAGE.PAYMENT_CREDIT_CARD_ERROR]: 'paymentCardError',
	[STATUS_MESSAGE.ADVERT_ACTION_ERROR]: 'advertActionError',
	[STATUS_MESSAGE.ADVERT_RESERVED_ERROR]: 'advertActionError',
	[STATUS_MESSAGE.ADVERT_NOT_ACTIVE]: 'advertNotActive',
	[STATUS_MESSAGE.FAVORITE_GENERIC_ADD_ERROR]: 'favoriteGenericAddError',
	[STATUS_MESSAGE.FAVORITE_GENERIC_REMOVE_ERROR]: 'favoriteGenericRemoveError',
	[STATUS_MESSAGE.WATCH_DOG_DOESNT_EXIST_ERROR]: 'watchDogDoesntExistErrorMsg',
	[STATUS_MESSAGE.WATCH_DOG_CREATED_SUCCESS]: 'watchDogCreatedSuccessMsg',
	[STATUS_MESSAGE.WATCH_DOG_CREATED_ERROR]: 'watchDogCreatedErrorMsg',
	[STATUS_MESSAGE.WATCH_DOG_UPDATED_SUCCESS]: 'watchDogUpdatedSuccessMsg',
	[STATUS_MESSAGE.WATCH_DOG_UPDATED_ERROR]: 'watchDogUpdatedErrorMsg',
	[STATUS_MESSAGE.WATCH_DOG_DELETED_SUCCESS]: 'watchDogDeletedSuccessMsg',
	[STATUS_MESSAGE.WATCH_DOG_DELETED_ERROR]: 'watchDogDeletedErrorMsg',
	[STATUS_MESSAGE.BANKID_STATUS_SUCCESS]: 'bankIdStatusSuccessMsg',
	[STATUS_MESSAGE.BANKID_STATUS_MISMATCH]: 'bankIdStatusMismatchMsg',
	[STATUS_MESSAGE.BANKID_STATUS_ERROR]: 'bankIdStatusErrorMsg',
	[STATUS_MESSAGE.BANKID_STATUS_ACCESS_DENIED]: 'bankIdStatusAccessDeniedMsg',
	[STATUS_MESSAGE.BANKID_STATUS_EID_DOESNT_EXIST]: 'bankIdStatusEidDoesntExistMsg',
	[STATUS_MESSAGE.MOJEID_STATUS_SUCCESS]: 'mojeIdStatusSuccessMsg',
	[STATUS_MESSAGE.MOJEID_STATUS_MISMATCH]: 'mojeIdStatusMismatchMsg',
	[STATUS_MESSAGE.MOJEID_STATUS_ERROR]: 'mojeIdStatusErrorMsg',
	[STATUS_MESSAGE.MOJEID_STATUS_INCOMPLETE]: 'mojeIdStatusIncompleteMsg',

	// TODO: doplnit zbyvajici statusy
	[STATUS_MESSAGE.LOCATING_TIMEOUT]: '',
} as const;
